import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardNav from "../components/Nav/DashboardNav";
import Footer from "../components/Footer/Footer";
import { FiSliders, FiSearch, FiChevronDown } from "react-icons/fi";
import searchicon from "../components/assets/searchicon.svg";
import writeicon from "../components/assets/writereview.svg";
import submiticon from "../components/assets/submit.svg"
import { ReactComponent as VendorSearchImage } from "../components/assets/vendorsearchimage.svg";
import { ReactComponent as SearchIcon } from "../components/assets/searchicon2.svg"

const ClaimBusiness = ({ vendorData }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = (value) => {
    setSearch(value);
    if (value.trim() === "") {
      setFilteredVendors([]);
      setDropdownVisible(false);
      return;
    }
    const filtered = vendorData.filter((v) =>
      v.vendor_name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredVendors(filtered);
    setDropdownVisible(true);
  };

  const handleClaim = (vendor) => {
    navigate("/submit", {
      state: {
        mode: "claim",
        vendorId: vendor.vendor_id,
        vendorData: vendor,
      },
    });
    setDropdownVisible(false);
  };

  return (
    <div>
      <DashboardNav />
      <div className=' login flex flex-row  items-center  gap-[0]  pt-[99px] overflow-hidden sm:pt-[112px] md:pt-[120px] mg:pt-[14vh]   '>
        <div className="flex-1 flex justify-center items-center self-center">
          <div className=" bg-white px-[22px] pt-[0px] pb-[32px] md:px-[32px] w-full overflow-auto  xl:px-[64px]">
            <div className="w-full lg:flex-1 flex flex-col justify-center items-center text-center gap-[5px] lg:gap-[15px]  rounded-t-[30px] "
            >
              <div className="w-full lg:flex-1 h-[209px] flex flex-col justify-center xl:mb-[28px]  items-center text-center gap-[5px] lg:gap-[15px] rounded-t-[30px] "
                style={{
                  background: "linear-gradient(180deg, #FFDDA9 0%, rgba(255, 221, 169, 0) 100%)",
                  borderTopLeftRadius: "30px",
                  borderTopRightRadius: "30px",
                  paddingTop: "20px",
                }}
              >
                <p className='flex flex-col text-black font-black mt-0 text-[24px] lg:text-[32px] xl:mt-[34px] md:leading-[30.2px]] xl:text-[42px] xl:leading-[40.5px]'> Lets claim your business</p>
                <p className=' font-medium md:w-[395px] mb-[28px] md:mb-[50px] lg:mt-[0px] w-[251px] xl:mb-[45px] xl:w-full lg:text-nowrap text-black text-[16px] '>Take control of your business profile and reach more customers</p>

              </div>
            </div>


            {/* Search Box */}
            <div className="w-full relative md:px-[135px] lg:mb-[50px] lg:px-[217px] xl:px-[425px]" ref={containerRef}>
              <div className="flex items-center bg-white border border-[#c1c1c1]/50 rounded-full shadow-md overflow-hidden h-[45px]">
                <button className="flex items-center gap-2 pl-5 pr-3 text-gray-600 hover:text-black">
                  <FiSliders className="text-lg" />
                  <span className="text-[14px] font-normal">Filters</span>
                  <FiChevronDown className="text-sm" />
                </button>
                <div className="h-6 w-[1px] bg-gray-200" />
                <input
                  type="text"
                  placeholder="Search vendor"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="flex-1 pl-2 text-[16px] outline-none"
                />
                <button className="h-full px-3 bg-ravblue flex items-center justify-center">
                  <SearchIcon className="w-4 h-4 " />
                </button>
              </div>

              {/* Dropdown */}
              {dropdownVisible && filteredVendors.length > 0 && (
                <div className=" mt-2.5 w-full bg-white rounded-xl shadow-lg max-h-64 overflow-y-auto z-50">
                  {filteredVendors.map((vendor) => (
                    <div
                      key={vendor.vendor_id}
                      onClick={() => handleClaim(vendor)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleClaim(vendor);
                      }}
                      className="flex items-start gap-3 px-4 py-3 rounded-lg hover:bg-gray-100 cursor-pointer focus:outline-none focus:bg-gray-100"
                    >
                      {/* Icon */}
                      <VendorSearchImage className="w-6 h-6 mt-1" />

                      {/* Vendor info */}
                      <div className="flex flex-col">
                        <span className="font-bold text-[16px] text-black">
                          {vendor.vendor_name}
                        </span>

                        <span className="text-[10px] text-[#aaaaaa] font-medium">
                          Claim this business
                        </span>
                      </div>
                    </div>

                  ))}
                </div>
              )}

              {/* Empty message */}
              {dropdownVisible && filteredVendors.length === 0 && (
                <div className="absolute mt-1 w-full bg-white rounded-xl shadow-lg p-3 text-gray-500">
                  No vendors found.
                </div>
              )}
            </div>
            <div className="flex flex-col items-center mt-[65px] lg:mt-[33px] xl:mt-[50px] w-full">
              {/* 🧭 Steps Container */}
              <div className="w-full max-w-[1100px] mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">

                  {/* Step 1 */}
                  <div className="flex flex-col items-center text-center gap-3">
                    <img src={searchicon} alt="Search" className="w-10 h-10" />

                    <h3 className="font-bold text-[18px] lg:text-[24px]">
                      Search for business
                    </h3>

                    <p className="text-[#AAAAAA] text-[14px] lg:text-[16px] max-w-[260px]">
                      Enter business name in the search bar. If it already exists, select it
                      from the results to begin the claim process.
                    </p>
                  </div>

                  {/* Step 2 */}
                  <div className="flex flex-col items-center text-center gap-3">
                    <img src={writeicon} alt="Write" className="w-10 h-10" />

                    <h3 className="font-bold text-[18px] lg:text-[24px]">
                      Edit details
                    </h3>

                    <p className="text-[#AAAAAA] text-[14px] lg:text-[16px] max-w-[260px]">
                      Provide the correct business information to ensure your listing is
                      verified quickly.
                    </p>
                  </div>

                  {/* Step 3 */}
                  <div className="flex flex-col items-center text-center gap-3">
                    <img src={submiticon} alt="Submit" className="w-10 h-10" />

                    <h3 className="font-bold text-[18px] lg:text-[24px]">
                      Submit
                    </h3>

                    <p className="text-[#AAAAAA] text-[14px] lg:text-[16px] max-w-[260px]">
                      Once you’ve confirmed everything looks good, hit Submit.
                    </p>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ClaimBusiness;
